import React from 'react';
import { observer } from 'mobx-react-lite';
import { cardsStore } from '../../store/cardsStore';
import {
  BANKER_CARDS_BOX,
  CARDS_TYPE_BETSHOP,
  HORIZONTAL_CARDS_INDEX,
} from '../../enums/cardTypes';
import { IDS } from '../../enums/constants';

export const BetShopBankerCards = observer(() => {
  const { bankerCards } = cardsStore;

  return (
    <div className='bb-cards bb-right-deck'>
      {BANKER_CARDS_BOX.map((item, index) => {
        const card = bankerCards.length > 1 - index ? bankerCards[1 - index] : null;
        return (
          <div className='bb-card-holder' key={IDS[index]}>
            <div className={`bb-card ${Number.isInteger(card?.card) ? 'open' : ''}`}>
              <div className={`bb-card-front ${CARDS_TYPE_BETSHOP[card?.card]}`} />
              <div className='bb-card-back' />
            </div>
          </div>
        );
      })}
      <div className='bb-card-holder'>
        <div
          className={`bb-card ${
            CARDS_TYPE_BETSHOP[bankerCards[HORIZONTAL_CARDS_INDEX]?.card] ? 'open' : ''
          }`}
        >
          <div
            className={`bb-card-front ${
              bankerCards.length > HORIZONTAL_CARDS_INDEX && bankerCards[HORIZONTAL_CARDS_INDEX]
                ? CARDS_TYPE_BETSHOP[bankerCards[HORIZONTAL_CARDS_INDEX].card]
                : ''
            }`}
          />
          <div className='bb-card-back' />
        </div>
      </div>
    </div>
  );
});
